import React, { memo, useCallback } from 'react';
import ScaleButtonsRow from '@modules/performance/components/scale-buttons/scale-button';
import CompetencyCommentSection from './competency-comment-section';

interface CompetencyRatingSectionProps {
  competencyId: string;
  scales: any[];
  selectedScaleId?: string;
  selectedScale?: any;
  userName: string;
  comment: string;
  showComment: boolean;
  canEdit: boolean;
  canSelect: boolean;
  isEditing: boolean;
  editingValue: string;
  validationError?: string;
  fallbackLabel: string;
  onScaleSelect: (competencyId: string, scaleId: string) => void;
  onEdit: (competencyId: string, comment: string) => void;
  onSave: (competencyId: string) => void;
  onCancel: () => void;
  onEditingValueChange: (value: string) => void;
}

const CompetencyRatingSection = memo<CompetencyRatingSectionProps>(({
  competencyId,
  scales,
  selectedScaleId,
  selectedScale,
  userName,
  comment,
  showComment,
  canEdit,
  canSelect,
  isEditing,
  editingValue,
  validationError,
  fallbackLabel,
  onScaleSelect,
  onEdit,
  onSave,
  onCancel,
  onEditingValueChange,
}) => {
  const handleScaleSelect = useCallback((id: string) => {
    if (canSelect) {
      onScaleSelect(competencyId, id);
    }
  }, [canSelect, onScaleSelect, competencyId]);

  return (
    <div className="tw-flex tw-flex-col tw-gap-3">
      <div className="tw-text-gray-textDark tw-text-base tw-font-semibold">
        {userName}
      </div>
      <ScaleButtonsRow
        scales={scales}
        selectedScaleId={selectedScaleId}
        selectedScale={selectedScale}
        fallbackLabel={fallbackLabel}
        onSelect={handleScaleSelect}
        disabled={!canSelect}
      />
      {validationError && (
        <div className="tw-text-red-500 tw-mt-1 tw-text-sm">
          {validationError}
        </div>
      )}
      <CompetencyCommentSection
        competencyId={competencyId}
        comment={comment}
        showComment={showComment}
        isEditing={isEditing}
        editingValue={editingValue}
        canEdit={canEdit}
        onEdit={onEdit}
        onSave={onSave}
        onCancel={onCancel}
        onEditingValueChange={onEditingValueChange}
      />
    </div>
  );
});

CompetencyRatingSection.displayName = 'CompetencyRatingSection';

export default CompetencyRatingSection;
